import { all, takeLatest } from 'redux-saga/effects';

import { ReposTypes } from '../ducks/repos';
import { getReposRequest } from './repos';
import { SkillsTypes } from '../ducks/skills';
import { getSkillsRequest } from './skills';
import { MessageTypes } from '../ducks/message';
import { sendMessageRequest } from './message';
import { LoaderTypes } from '../ducks/loader';
import { startLoaderRequest, stopLoaderRequest } from './loader';
import { ExperienceTypes } from '../ducks/experience';
import { getExperienceRequest } from './experience';
import { AcademicTypes } from '../ducks/academic';
import { getAcademicRequest } from './academic';

export default function* rootSaga() {
  yield all([
    takeLatest(ReposTypes.GET_REPOS_REQUEST, getReposRequest),
    takeLatest(SkillsTypes.GET_SKILLS_REQUEST, getSkillsRequest),
    takeLatest(MessageTypes.SEND_MESSAGE_REQUEST, sendMessageRequest),
    takeLatest(LoaderTypes.START_LOADER_REQUEST, startLoaderRequest),
    takeLatest(LoaderTypes.STOP_LOADER_REQUEST, stopLoaderRequest),
    takeLatest(ExperienceTypes.GET_EXPERIENCE_REQUEST, getExperienceRequest),
    takeLatest(AcademicTypes.GET_ACADEMIC_REQUEST, getAcademicRequest),
  ]);
}
